const FALLBACK_PROFILE_SLUG = 'profile';
const FALLBACK_QUESTION_SLUG = 'question';
const OBJECT_ID_HEX_PATTERN = /^[0-9a-fA-F]{24}$/;

export const slugify = (value = '') =>
  String(value)
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '-')
    .replace(/[^\w-]+/g, '')
    .replace(/-+/g, '-');

export const getProfileSlug = (user) =>
  slugify(user?.name || user?.username || '') || FALLBACK_PROFILE_SLUG;

export const getQuestionSlug = (question) =>
  slugify(question?.question || '') || FALLBACK_QUESTION_SLUG;

export const encodeUserIdSlug = (value) => {
  if (!value) {
    return '';
  }

  const normalizedValue = String(value).trim();
  if (!OBJECT_ID_HEX_PATTERN.test(normalizedValue)) {
    return '';
  }

  const binary = normalizedValue
    .toLowerCase()
    .match(/.{2}/g)
    .map((hexPair) => String.fromCharCode(parseInt(hexPair, 16)))
    .join('');

  return btoa(binary)
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/g, '');
};

export const getUserIdSlug = (user) => {
  if (user?.idSlug) {
    return String(user.idSlug);
  }

  const userId = user?._id || user?.id;
  return encodeUserIdSlug(userId);
};

export const buildPublicProfilePath = (user) => {
  const username = user?.username;
  if (username) {
    return `/ask/${username}`;
  }

  const profileSlug = getProfileSlug(user);
  return profileSlug ? `/ask/${profileSlug}` : '';
};

export const buildPublicQuestionPath = (user, question) => {
  const profilePath = buildPublicProfilePath(user);
  const questionId = question?._id || question?.id;

  if (!profilePath || !questionId) {
    return '';
  }

  return `${profilePath}/question/${questionId}/${getQuestionSlug(question)}`;
};
